module.exports = __webpack_public_path__ + "img/total-bg@2x.e15a6c2c.png";